import { render } from "./smartChat.vue?vue&type=template&id=65e6aba6"
import script from "./smartChat.vue?vue&type=script&lang=js"
export * from "./smartChat.vue?vue&type=script&lang=js"

import "./smartChat.vue?vue&type=style&index=0&id=65e6aba6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__